<div class="main-view space-y-4">
    <app-page-surface-header
        titleIcon="settings"
        title="System Preferences"
        subtitle="Manage roles, platform settings, email templates, and organization details."
    />

    <div class="border-b border-gray-200 dark:border-[#191e3a]">
        <nav class="flex flex-wrap gap-0 -mb-px" aria-label="System preference tabs">
            @if (canAccessTab('manage-roles')) {
            <button type="button" (click)="setTab('manage-roles')" [class]="
                    'px-4 py-3 text-sm font-medium border-b-2 transition-colors ' +
                    (activeTab === 'manage-roles'
                        ? 'border-[#7c3aed] text-[#7c3aed]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200')
                ">
                Manage Roles
            </button>
            }
            @if (canAccessTab('stimulate-agent')) {
            <button type="button" (click)="setTab('stimulate-agent')" [class]="
                    'px-4 py-3 text-sm font-medium border-b-2 transition-colors ' +
                    (activeTab === 'stimulate-agent'
                        ? 'border-[#7c3aed] text-[#7c3aed]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200')
                ">
                Stimulate Agent
            </button>
            }
            @if (canAccessTab('smtp')) {
            <button type="button" (click)="setTab('smtp')" [class]="
                    'px-4 py-3 text-sm font-medium border-b-2 transition-colors ' +
                    (activeTab === 'smtp'
                        ? 'border-[#7c3aed] text-[#7c3aed]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200')
                ">
                Manage SMTP Settings
            </button>
            }
            @if (canAccessTab('tenant-email')) {
            <button type="button" (click)="setTab('tenant-email')" [class]="
                    'px-4 py-3 text-sm font-medium border-b-2 transition-colors ' +
                    (activeTab === 'tenant-email'
                        ? 'border-[#7c3aed] text-[#7c3aed]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200')
                ">
                Email Template
            </button>
            }
            @if (canAccessTab('organization')) {
            <button type="button" (click)="setTab('organization')" [class]="
                    'px-4 py-3 text-sm font-medium border-b-2 transition-colors ' +
                    (activeTab === 'organization'
                        ? 'border-[#7c3aed] text-[#7c3aed]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200')
                ">
                Organization Details
            </button>
            }
        </nav>
    </div>

    @if (activeTab === 'manage-roles' && canAccessTab('manage-roles')) {
    <app-manage-roles />
    }

    @if (activeTab === 'stimulate-agent' && canAccessTab('stimulate-agent')) {
    <div class="rounded-3xl bg-white/70 p-6 shadow-none dark:bg-white/10">
        <div class="mb-6">
            <h2 class="text-base font-semibold text-black dark:text-white">Stimulate Agent</h2>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
                Choose how document OCR runs when you simulate an agent. Leave unset to use the default (AI).
            </p>
        </div>

        @if (loadError) {
        <div class="mb-4 flex flex-wrap items-center gap-2 text-sm text-danger">
            <span>{{ loadError }}</span>
            <button type="button" class="btn btn-sm rounded-full px-3 py-1" (click)="loadSimulateAgentMethod()">
                Retry
            </button>
        </div>
        }

        @if (methodLoading) {
        <p class="text-sm text-gray-500 dark:text-gray-400">Loading setting…</p>
        } @else {
        <fieldset class="mb-6">
            <legend class="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                Document OCR method
            </legend>
            <div class="flex flex-col gap-3 sm:flex-row sm:gap-6">
                <label class="inline-flex cursor-pointer items-center gap-2 text-sm text-black dark:text-white">
                    <input type="radio" name="simulateAgentMethod" class="form-radio text-[#7c3aed]" value="ai"
                        [(ngModel)]="simulateAgentMethod" />
                    AI
                    <span class="text-gray-400">(Vision OCR)</span>
                </label>
                <label class="inline-flex cursor-pointer items-center gap-2 text-sm text-black dark:text-white">
                    <input type="radio" name="simulateAgentMethod" class="form-radio text-[#7c3aed]" value="idp"
                        [(ngModel)]="simulateAgentMethod" />
                    IDP
                    <span class="text-gray-400">(KatDev document APIs)</span>
                </label>
            </div>
            @if (!simulateAgentMethod) {
            <p class="mt-2 text-xs text-gray-400 dark:text-gray-500">
                Not set yet — simulation uploads will use AI until you choose a method.
            </p>
            }
        </fieldset>

        @if (saveError) {
        <p class="mb-3 text-sm text-danger" role="alert">{{ saveError }}</p>
        }

        @if (P.SIMULATE_AGENT_SETTINGS_UPDATE | hasPermission) {
        <button type="button"
            class="btn rounded-full bg-[#303030] px-6 py-2.5 text-white hover:bg-black disabled:opacity-50"
            [disabled]="!canSave" (click)="saveStimulateAgent()">
            {{ saving ? 'Saving…' : 'Save' }}
        </button>
        }
        }
    </div>
    }

    @if (activeTab === 'smtp' && canAccessTab('smtp')) {
    <app-smtp-settings />
    }

    @if (activeTab === 'tenant-email' && canAccessTab('tenant-email')) {
    <app-email-configuration />
    }

    @if (activeTab === 'organization' && canAccessTab('organization')) {
    <app-organization-settings />
    }
</div>
